(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('SbfTimeSlotSearch', SbfTimeSlotSearch);

    SbfTimeSlotSearch.$inject = ['$resource'];

    function SbfTimeSlotSearch($resource) {
        var resourceUrl =  'api/_search/sbf-time-slots/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
